import { Link } from "react-router-dom";
import { collections } from "@/mocks/collections";
import { comics } from "@/mocks/comics";

export default function FeaturedCollections() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="mb-7">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
          推荐专题合集
        </h2>
        <p className="text-sm text-foreground-500 mt-2">
          编辑精选专题，帮你按心情和主题一站式发现好作品
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
        {collections.map((collection) => {
          const members = collection.comicIds
            .map((id) => comics.find((item) => item.id === id))
            .filter((item): item is (typeof comics)[number] => Boolean(item));
          return (
            <article
              key={collection.id}
              className="group relative rounded-lg overflow-hidden border border-background-200"
            >
              <div className="relative w-full h-[300px] md:h-[340px]">
                <img
                  src={collection.image}
                  alt={`${collection.title} 韩漫专题`}
                  title={`${collection.title} 韩漫合集`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/45 to-black/10"></div>
              </div>
              <div className="absolute inset-0 flex flex-col justify-end p-5">
                <span className="inline-flex w-fit items-center gap-1 px-2.5 py-0.5 rounded-full bg-secondary-500 text-white text-[11px] font-medium mb-3">
                  {collection.tag}
                </span>
                <h3 className="font-heading font-bold text-white text-lg md:text-xl">
                  {collection.title}
                </h3>
                <p className="text-white/80 text-xs md:text-sm mt-2 leading-relaxed line-clamp-2">
                  {collection.description}
                </p>
                <div className="flex items-center gap-3 mt-4">
                  <div className="flex -space-x-2">
                    {members.slice(0, 4).map((comic) => (
                      <img
                        key={comic.id}
                        src={comic.cover}
                        alt={comic.title}
                        title={comic.title}
                        className="w-9 h-9 rounded-full object-cover object-top border-2 border-white/70"
                      />
                    ))}
                  </div>
                  <Link
                    to="/category"
                    className="ml-auto inline-flex items-center gap-1 text-xs md:text-sm text-white/90 hover:text-white whitespace-nowrap"
                  >
                    查看合集
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}